import { render } from "./SkeletonWidget.vue?vue&type=template&id=082ed4e9"
import script from "./SkeletonWidget.vue?vue&type=script&lang=js"
export * from "./SkeletonWidget.vue?vue&type=script&lang=js"

import "./SkeletonWidget.vue?vue&type=style&index=0&id=082ed4e9&lang=css"

import exportComponent from "/var/www/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__